/*
 * @Author: your name
 * @Date: 2022-04-29 16:45:59
 * @LastEditTime: 2025-12-15 13:53:52
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecgboot-vue3\src\components\do\index.tsx
 */
import { selectProps } from 'ant-design-vue/es/select';
import { initDefaultProps } from 'ant-design-vue/es/_util/props-util';
import { defineComponent, onBeforeUnmount, ref, watch, watchEffect } from 'vue';
import { Plugin } from '@vue/runtime-dom';
import { Spin } from 'ant-design-vue';
import { propTypes } from '/@/utils/propTypes';
import { esHelper } from '/@/utils/http/es_utils/es_helper';
import type { PropType } from 'vue';
import { CaretDownOutlined, LoadingOutlined } from '@ant-design/icons-vue';
import { useI18n } from '/@/hooks/web/useI18n';
import './index.less';

const DROPDOWN_ALIGN = {
  overflow: {
    adjustX: true,
    adjustY: false,
  },
};

function resolvePopupContainer(
  node: HTMLElement | undefined,
  custom?: (node: HTMLElement) => HTMLElement
) {
  if (typeof custom === 'function') {
    return custom(node as HTMLElement);
  }
  return (
    (node?.closest('.component-divider') as HTMLElement | null) ??
    (node?.parentNode as HTMLElement | null) ??
    document.body
  );
}

const jprops = {
  ...initDefaultProps(selectProps(), {
    listHeight: 256,
    listItemHeight: 24,
  }),
  style: {
    type: Object as PropType<import('vue').CSSProperties>,
  },
  placeholder: {
    type: String,
    default: '请选择',
    required: false,
  },
  pidValue: {
    type: String,
    default: '',
    required: false,
  },
  includeChildren: {
    type: Boolean,
    default: '',
    required: false,
  },
  selectedCode: {
    type: String,
    default: '',
    required: false,
  },
  customSource: propTypes.func,
  labelField: propTypes.string,
  valueField: propTypes.string,
  allowClear: {
    type: Boolean,
    default: true,
    required: false,
  },
  defaultValue: {
    type: String,
  },
  autoSelectFirst: {
    type: Boolean,
    default: false,
  },
  labelEqualsValue: {
    type: Boolean,
    default: false,
    required: false,
  },
  bordered: {
    type: Boolean,
    default: true,
  },
  t: propTypes.func,
  excludeIds: {
    type: Array,
    default: [],
    required: false,
  },
};

const comp = defineComponent({
  props: jprops,
  emits: ['update:value', 'change', 'selectItem'],
  setup(props, ctx) {
    const { t: i18nT } = useI18n();
    const wrapperRef = ref<HTMLElement>();
    const data = ref<any[]>([]);
    const loading = ref(false);
    let loadToken = 0;
    let scrollCleanup: (() => void) | null = null;
    const cachePid = ref<string>();
    const selectedValue = ref<string | string[]>('');

    const cleanupScrollSync = () => {
      scrollCleanup?.();
      scrollCleanup = null;
    };

    const handleDropdownVisibleChange = (open: boolean) => {
      props.onDropdownVisibleChange?.(open);
      cleanupScrollSync();
      if (!open) {
        return;
      }
      requestAnimationFrame(() => {
        const scrollContainer = wrapperRef.value?.closest('.component-divider') as HTMLElement | null;
        if (!scrollContainer) {
          return;
        }
        const realign = () => window.dispatchEvent(new Event('resize'));
        scrollContainer.addEventListener('scroll', realign, { passive: true });
        scrollCleanup = () => scrollContainer.removeEventListener('scroll', realign);
      });
    };

    onBeforeUnmount(cleanupScrollSync);

    const handlePopupContainer = (node: HTMLElement) =>
      resolvePopupContainer(node, props.getPopupContainer as ((node: HTMLElement) => HTMLElement) | undefined);

    const buildMeta = () => ({
      ...props,
      onChange: (newval) => {
        if (props.mode === 'multiple') {
          const newLable = data.value
            .filter((x) => newval.includes(x.value))
            .map((item) => {
              return item?.label ?? item?.name;
            });
          ctx.emit('update:value', newval);
          ctx.emit('change', newval, newLable ?? []);
          ctx.emit(
            'selectItem',
            data.value.filter((x) => newval.includes(x.value))
          );
        } else {
          const newLable = data.value.filter((x) => x.value === newval)[0]?.label;
          ctx.emit('update:value', newval);
          ctx.emit('change', newval, newLable ?? '');
          ctx.emit('selectItem', data.value.filter((x) => x.value === newval)[0]?.data);
        }
      },
      'onUpdate:value': undefined,
    });

    const meta = ref<any>(buildMeta());
    watch(props, async () => {
      meta.value = buildMeta();
    });

    const applyExcludeIds = (items: any[]) => {
      if (!props.excludeIds?.length) {
        return items;
      }
      return items.filter((x) => !props.excludeIds.includes(x.data?.id ?? x.value));
    };

    const loadData = async () => {
      const token = ++loadToken;
      const willFetch =
        !!props.customSource || (cachePid.value !== props.pidValue && !!props.pidValue);
      if (willFetch) {
        loading.value = true;
      }
      try {
        if (props.customSource) {
          const res = await props.customSource();
          if (token !== loadToken) return;
          data.value = applyExcludeIds(
            res.map((r) => ({
              ...r,
              [props.labelField ?? 'label']: props.t
                ? props.t(r[props.labelField ?? 'label'])
                : r[props.labelField ?? 'label'],
            }))
          );
        } else {
          if (cachePid.value !== props.pidValue && props.pidValue) {
            cachePid.value = props.pidValue;
            const res = await esHelper.findEnumsByPid(
              props.pidValue,
              props.selectedCode,
              props.includeChildren
            );
            if (token !== loadToken) return;
            if (props.labelEqualsValue) {
              data.value = res.result.map((r) => ({
                value: r.name,
                label: props.t ? props.t(r.name) : r.name,
                data: r,
              }));
            } else {
              data.value = res.result.map((r) => ({
                value: r.id,
                label: props.t ? props.t(r.name) : r.name,
                data: r,
              }));
            }
            if (props.excludeIds && props.excludeIds.length > 0) {
              data.value = applyExcludeIds(data.value);
            }
          }
        }
        if (props.defaultValue) {
          if (data.value.length > 0 && !props.value) {
            const item = data.value.find(
              (x) => x[props.valueField] === props.defaultValue || x.value === props.defaultValue
            );
            if (item) {
              selectedValue.value = item.value;
              meta.value?.onChange(selectedValue.value);
              return;
            }
          }
        }

        if (props.autoSelectFirst) {
          if (data.value.length > 0 && !props.value) {
            const item = data.value[0];
            selectedValue.value = props.valueField ? item[props.valueField] : item.value;
            meta.value?.onChange(selectedValue.value);
            return;
          }
        }
        await preCheck();
      } finally {
        if (token === loadToken && willFetch) {
          loading.value = false;
        }
      }
    };

    const preCheck = async () => {
      if (props.customSource) {
        return;
      }

      const valueKey = props.valueField ?? 'value';
      const optionValues = data.value?.map((x) => x[valueKey]) ?? [];
      if (!optionValues.length) {
        return;
      }

      if (props.mode === 'multiple') {
        const current = Array.isArray(selectedValue.value)
          ? selectedValue.value
          : selectedValue.value
            ? [String(selectedValue.value)]
            : [];
        if (!current.length) {
          return;
        }
        const hasMissing = current.some((v) => v && !optionValues.includes(v));
        if (hasMissing) {
          return;
        }
        return;
      }

      const current = String(selectedValue.value ?? '');
      if (current && !optionValues.includes(current)) {
        const res = await esHelper.findByCondition({
          id: current,
          force: true,
        });
        if (res?.result?.[0]?.name) {
          selectedValue.value = res.result[0].name;
        }
      }
    };

    watchEffect(async () => {
      if (props.mode === 'multiple') {
        selectedValue.value = Array.isArray(props.value)
          ? props.value
          : props.value
            ? String(props.value).split(',').filter(Boolean)
            : [];
      } else {
        selectedValue.value = (props.value ?? '') as string;
      }
      if (props.pidValue || props.customSource) {
        await loadData();
      }
    });

    return {
      meta,
      data,
      selectedValue,
      loading,
      loadData,
      i18nT,
      wrapperRef,
      handlePopupContainer,
      handleDropdownVisibleChange,
    };
  },
  render() {
    const loadingContent = (
      <div
        class="d-select-loading"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '12px 0',
          gap: '8px',
        }}
      >
        <Spin size="small" />
        <span style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '14px' }}>
          {this.i18nT('加载中...')}
        </span>
      </div>
    );

    return (
      <div ref={this.wrapperRef} class="d-select-root">
        <a-select
          {...this.meta}
          value={this.selectedValue}
          placement="bottomLeft"
          dropdownAlign={DROPDOWN_ALIGN}
          getPopupContainer={this.handlePopupContainer}
          onDropdownVisibleChange={this.handleDropdownVisibleChange}
          options={this.data}
          loading={this.loading}
          notFoundContent={this.loading ? loadingContent : undefined}
          fieldNames={{ label: this.labelField, value: this.valueField }}
          bordered={this.$props.bordered}
          suffixIcon={
            this.loading ? <LoadingOutlined spin class="d-select-loading-icon" /> : <CaretDownOutlined />
          }
        >
          option
        </a-select>
      </div>
    );
  },
});

export const DSelect: Plugin = {
  install: (app) => {
    app.component('DSelect', comp);
  },
};
